const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Universal URL resolver - handles relative, absolute, and old domain URLs
const resolveUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('/')) return `${BACKEND_URL}${url}`;
  // Fix old absolute URLs from previous deployments
  if (url.includes('preview.emergentagent.com/api/uploads')) {
    const match = url.match(/\/api\/uploads\/.+/);
    if (match) return `${BACKEND_URL}${match[0]}`;
  }
  return url;
};

export { BACKEND_URL, API, resolveUrl };
